import {jsx as _jsx} from "react/jsx-runtime";
export let frontmatter = {
  "title": "Changelogs",
  "description": "Notas de versión de Orkestria. Selecciona una versión para ver todo lo nuevo."
};
export let structuredData = {
  "contents": [],
  "headings": []
};
import {ChangelogVersionPicker} from "@/components/docs/ChangelogVersionPicker";
export let toc = [];
function _createMdxContent(props) {
  return _jsx(ChangelogVersionPicker, {
    versions: [{
      id: "0.3.1-beta",
      label: "0.3.1-beta",
      tag: "Más reciente",
      date: "2026-05-14",
      summary: "Navegación móvil personalizable, refinamientos en arrastrar y soltar, mejoras en formularios y nuevo centro de documentación."
    }, {
      id: "0.3.0-beta",
      label: "0.3.0-beta",
      tag: "Inicial",
      date: "2026-04-25",
      summary: "Lanzamiento inicial: gestión completa de restaurante, asistente Faki, múltiples roles, carta digital y reportes."
    }]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
